import VueCookie from 'vue-cookie'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import qs from 'qs'
import merge from 'lodash/merge'
import {clearLoginInfo} from '@/utils'
import element from 'element-ui'

const http = axios.create({
  timeout: 1000 * 300,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  let userToken = store.state.user.token;
  if (userToken === undefined || userToken === null || userToken.length === 0) {
    let cookieToken = VueCookie.get('zf-token');
    store.commit('user/updateToken', cookieToken)
    userToken = cookieToken;
  }
  config.headers['token'] = userToken // 请求头带上token
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {
  if (response.data && response.data.code === 401) { // 401, token失效
    clearLoginInfo()
    router.push({name: 'login'})
  }
  if (response.data && response.data.code === 500){
    element.Message.error(response.data.msg)
  }
  return response
}, error => {
  if (error.code === 'ECONNABORTED'){
    element.Message.error('连接超时')
  }else {
    if (error.response !==undefined && error.response.status !== undefined){
      element.Message.error(error.response.statusText)
    }
  }
  return Promise.reject(error)
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
http.adornUrl = (actionName) => {
  //针对后台API，使用nginx转发/gzh/字段到后台API
  return window.location.protocol + "//" + window.location.hostname + ":" + window.location.port + "/zf" + actionName;
  // if (false == window.SITE_CONFIG.isSEP) {
  //   return window.location.protocol+ "//" +window.location.hostname + ":" + window.location.port + "/gzh" + actionName
  // }
  // else {
  //   return window.SITE_CONFIG.baseUrl + actionName
  // }
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    't': new Date().getTime()
  }
  return openDefultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
http.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
  var defaults = {
    't': new Date().getTime()
  }
  data = openDefultdata ? merge(defaults, data) : data
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

export default http



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js